export default {
  'sendticket.sendticket': 'إرسال الطلب',
  'sendticket.sentsuccessfully': 'تم إرسال الطلب بنجاح',
  'sendticket.replytickets': 'الردود على الطلبات',
  'sendticket.you': 'أنت',
  'sendticket.operator': 'المشغل',
  'sendticket.reply': 'الرد',
  'sendticket.createdat': 'تم الإنشاء في',
  'sendticket.laststatus': 'آخر حالة',
  'sendticket.ticketid': 'معرف الطلب',
  'sendticket.closeticketquestion': 'هل تم الرد على طلبك بنجاح؟',
  'sendticket.closeticket': 'نعم، أغلق هذا الطلب',
  'sendticket.notcloseticket': 'لا',
  'sendticket.closedsuccessfully': 'تم إغلاق الطلب بنجاح',
  'sendticket.downloadfile': 'تحميل الملف',
  'sendticket.subject': 'الموضوع',
  'sendticket.ticketId': 'معرف الطلب',
  'sendticket.sender': 'المرسل',
  'sendticket.reply': 'الرد',
  'sendticket.yes': 'نعم، تم الرد',
  'sendticket.no': 'لم يتم بعد',
  'sendticket.pleaseTryAgain': 'يرجى المحاولة مرة أخرى',
  'sendticket.reply': 'الرد',
  'sendticket.today': '( اليوم )',
  'sendticket.yesterday': '( أمس )',
  'sendticket.daysago': 'أيام مضت',
  'sendticket.hoursago': 'ساعات مضت',
  'sendticket.minutesago': 'دقائق مضت',
  'sendticket.send': 'إرسال',
  'sendticket.description': 'الوصف',
  'sendticket.justnow': 'الآن',
};
